import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import cn from 'classnames';

import './CallKeyMomentFilters.scss';

const CallKeyMomentFilters = (props) => {
  const { getKeyMomentTypes, selectedKeyMomentTypes, calls } = props;
  const { keyMomentTypes } = calls;
  useEffect(() => {
    getKeyMomentTypes();
  }, [getKeyMomentTypes]);

  return (
    <div className='call-key-moment-types-outer-container'>
      <div className='section'>
        <div className='section-header'>Filter By Key Moments</div>
        <div className='types'>
          {keyMomentTypes?.map((type) => {
            const isSelected = _.find(selectedKeyMomentTypes, (t) => t.id === type.id);
            return (
              <div onClick={() => props.toggleKeyMomentTypeFilter(type)} key={type.id} className={cn('type', { selected: isSelected })}>
                {type.name}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

CallKeyMomentFilters.propTypes = {
  calls: PropTypes.object.isRequired,
  selectedKeyMomentTypes: PropTypes.array.isRequired,
  toggleKeyMomentTypeFilter: PropTypes.func.isRequired,
  getKeyMomentTypes: PropTypes.func.isRequired,
};

export default CallKeyMomentFilters;
